import React, { memo, useEffect, useRef, useState } from "react";

/** Minimal intersection-observer lazy image with srcset support */
const LazyImg = memo(function LazyImg({ src, srcset, sizes, alt, style, className, lazy = true }) {
  const ref = useRef(null);
  const [loaded, setLoaded] = useState(!lazy);

  useEffect(() => {
    if (!src || !lazy) return;
    const el = ref.current;
    if (!el) return;

    let obs;
    if ("IntersectionObserver" in window) {
      obs = new IntersectionObserver(
        (ents) => {
          for (const e of ents) {
            if (e.isIntersecting) {
              setLoaded(true);
              obs.disconnect();
              break;
            }
          }
        },
        { rootMargin: "200px" }
      );
      obs.observe(el);
    } else {
      setLoaded(true);
    }
    return () => obs && obs.disconnect();
  }, [src, lazy]);

  return (
    <img
      ref={ref}
      src={loaded ? src : undefined}
      srcSet={loaded && srcset ? srcset : undefined}
      sizes={loaded && srcset ? (sizes || "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw") : undefined}
      alt={alt}
      style={style}
      className={className}
      decoding="async"
      loading={lazy ? "lazy" : "eager"}
    />
  );
});

export default LazyImg;
